module.exports = __webpack_public_path__ + "assets/chevin-thin.a5084ae678fb9cc85373a36e2c027b8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/OP/chevin-thin.svg
// module id = 136
// module chunks = 0